import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../panel/components/Header";
import Sidebar from "../panel/components/Sidebar";
import apiClient from "../services/apiClient";
import { getCookie } from "../utils/cookies";

function loadCSS(href, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });
}

function removeCSS(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function removeScript(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

const loaderWrapperStyle = {
  height: "100vh",
  width: "100vw",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
};

const spinnerStyle = {
  width: "48px",
  height: "48px",
  border: "4px solid #e0e0e0",
  borderTopColor: "#007bff",
  borderRadius: "50%",
  animation: "panel-spin 0.8s linear infinite",
};

export default function PanelLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAccountActive, setIsAccountActive] = useState(false);

  const hideSidebar =
    location.pathname === "/panel/login" ||
    location.pathname === "/panel/signup";

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  const fetchAccountStatus = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");
      const res = await apiClient.post("/Dashboard/MataMaskDashboard", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setIsAccountActive(res.data?.isTopup === true);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (hideSidebar) return;

    function checkSession() {
      const hasSession =
        getCookie("session") && getCookie("sessionID") && getCookie("userData");
      if (!hasSession) {
        navigate("/panel/login", { replace: true });
      }
    }

    checkSession();
    fetchAccountStatus();
    const interval = setInterval(checkSession, 3000);
    document.addEventListener("visibilitychange", checkSession);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", checkSession);
    };
  }, [hideSidebar, navigate]);

  useEffect(() => {
    document.body.classList.toggle("sidebar-open", isSidebarOpen);
    return () => document.body.classList.remove("sidebar-open");
  }, [isSidebarOpen]);

  useEffect(() => {
    let isMounted = true;

    async function loadAssets() {
      await loadCSS("/assets/panel/css/style.css", "panel-css");

      try {
        await loadScript("/assets/panel/js/main-script.js", "panel-js");
      } catch (err) {
        console.error("Panel script load error:", err);
      }

      if (isMounted) {
        setIsLoading(false);
      }
    }

    loadAssets();

    return () => {
      isMounted = false;
      removeCSS("panel-css");
      removeScript("panel-js");
    };
  }, []);

  if (isLoading) {
    return (
      <div style={loaderWrapperStyle}>
        <style>
          {`
            @keyframes panel-spin {
              to { transform: rotate(360deg); }
            }
          `}
        </style>
        <div style={spinnerStyle}></div>
      </div>
    );
  }

  if (hideSidebar) {
    return <Outlet />;
  }

  return (
    <div id="app" className="active">
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        isAccountActive={isAccountActive}
      />
      <div className="main">
        <Header
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
        />
        <Outlet />
      </div>
    </div>
  );
}
